import without from 'lodash/without';
import find from 'lodash/find';

import { addLink, removeLink } from '../actions';
import { makeReducer } from '../utils';

const withoutThat = (array, that) => without(array, find(array, that));

export default makeReducer({
  addLink: (links, { path, label, iconComponent, index }) => [
    ...withoutThat(links, { path }),
    { path, label, iconComponent, index },
  ],
  removeLink: withoutThat,
}, { addLink, removeLink }, []); 
